import { useMutation, useQueryClient } from "react-query";

import { useApiClient } from "api/useApiClient";
import { QUERY_KEYS } from "types/QueryKeys";

import type { AppointmentV1, PostAppointmentV1Payload } from "../schemas/appointment_v1";

import { getAppointmentsV1QueryKeyPrefix } from "./useGetAppointmentsV1";

export const usePostAppointmentV1 = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<AppointmentV1, Error, PostAppointmentV1Payload>({
    mutationFn: args => client.postAppointmentV1(args),
    onSuccess: () => {
      queryClient.invalidateQueries(getAppointmentsV1QueryKeyPrefix);
      queryClient.invalidateQueries(QUERY_KEYS.patient.creatableCareEvents);
    },
  });
};
